import { CountryPicker, InsurerPicker, Show, TextInput } from "components/core";
import { FC, useState } from "react";
import { FormikProps, setIn } from "formik";

import { CreateReinsurerVariables } from "_graphql/mutation/__generated__/CreateReinsurer";

export interface ReInsurerFormProps {
  form: FormikProps<CreateReinsurerVariables["reinsurer"]>;
  update?: boolean;
}

const ReInsurerForm: FC<ReInsurerFormProps> = ({ form, update }) => {
  const [insurer, setInsurer] = useState(null);
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <Show if={Boolean(!update)}>
        <div>
          <span className="text-xs font-light">
            Add Resinsurer From existing Insurers
          </span>
          <div>
            <InsurerPicker
              id={"insurer"}
              label={"Insurer"}
              values={{ insurer }}
              setFieldValue={(key: string, value: any) => {
                form.setFieldValue(
                  "re_company_name",
                  value?.insurer_company_name
                );
                form.setFieldValue(
                  "re_company_email",
                  value?.insurer_company_email
                );
                form.setFieldValue(
                  "re_company_website",
                  value?.insurer_company_website
                );
                form.setFieldValue("country", value?.insurer_address?.country);
                form.setFieldValue("region", value?.insurer_address?.region);
                form.setFieldValue("suburb", value?.insurer_address?.suburb);
                form.setFieldValue("street", value?.insurer_address?.street);
              }}
              setFieldTouched={() => {}}
              setFieldError={() => {}}
            />
          </div>
        </div>
      </Show>
      <div className="pt-6">
        <span className="text-xs font-light">ReInsurer Details</span>
        <div className="grid grid-cols-2 gap-2">
          <div className="">
            <TextInput
              id="re_company_name"
              label="Company Name"
              type="text"
              placeholder="e.g. Visal Re-insurance"
              required={true}
              {...form}
            />
          </div>

          <div className="space-y-1 ">
            <TextInput
              id="re_company_email"
              label="Email"
              type="text"
              placeholder="e.g. visal@organization.com"
              required={true}
              {...form}
            />
          </div>

          <div className="space-y-1 col-span-2">
            <TextInput
              id="re_company_website"
              label="Webiste"
              type="text"
              placeholder="e.g. visalbrokers.org"
              required={true}
              {...form}
            />
          </div>
        </div>
      </div>
      <div className="pt-6">
        <span className="text-xs font-light">ReInsurer Address Details</span>
        <div className="grid grid-cols-2 gap-2">
          <div className="">
            <CountryPicker
              id="country"
              label="Country"
              placeholder="e.g. Ghana"
              required={true}
              {...form}
            />
          </div>

          <div className="space-y-1 ">
            <TextInput
              id="region"
              label="Region/State"
              type="text"
              placeholder="e.g. Greater Accra"
              required={true}
              {...form}
            />
          </div>

          <div className="space-y-1 ">
            <TextInput
              id="suburb"
              label="Suburb/city"
              type="text"
              placeholder="e.g. Accra"
              required={true}
              {...form}
            />
          </div>
          <div className="space-y-1 ">
            <TextInput
              id="street"
              label="Street Address"
              type="text"
              placeholder="e.g. Antelope Street"
              required={true}
              {...form}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReInsurerForm;
